// extracted by mini-css-extract-plugin
export default {"logos":"slderForw_logos__A6+gl","slide":"slderForw_slide__S6Cdh"};